import { GET_MENU_ITEMS, CATEGORY_UPDATE, MENU_RESET, CURRENT_USER_ADD, EMPLOYEES_ADD } from '../actions/index';

let initialState = {
  menuItems: {},
  employees: [],
  activeCategory: {},
  currentUser: {},
}

export default function(state = initialState, action) {
  switch(action.type) {
    case GET_MENU_ITEMS:
      return {
        ...state,
        menuItems: action.payload,
      }
    case CATEGORY_UPDATE:
      return {
        ...state,
        activeCategory: { id: action.id },
      }
    case CURRENT_USER_ADD:
      return {
        ...state,
        currentUser: action.payload,
      }
    case MENU_RESET:
      return {
        ...state,
        menuItems: {},
      }
    case EMPLOYEES_ADD:
      return {
        ...state,
        employees: action.payload,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_restaurant.js